import React from 'react';
import { FlexGridColumn, FlexGrid, FlexGridCellTemplate } from '@grapecity/wijmo.react.grid';
import * as wjcCore from '@grapecity/wijmo';
import { GroupPanel } from '@grapecity/wijmo.react.grid.grouppanel';
import '@grapecity/wijmo.styles/wijmo.css';
import { CellMaker } from '@grapecity/wijmo.grid.cellmaker';
import { FlexGridFilter } from '@grapecity/wijmo.react.grid.filter';
import * as wjGrid from '@grapecity/wijmo.grid';
import { ExportMode, ScaleMode, FlexGridPdfConverter } from '@grapecity/wijmo.grid.pdf';
import { PdfPageOrientation } from '@grapecity/wijmo.pdf';
import * as gridXlsx from '@grapecity/wijmo.grid.xlsx';
import { ListBox } from '@grapecity/wijmo.react.input';
import { showPopup, hidePopup, saveFile, Tooltip, PopupPosition } from '@grapecity/wijmo';
import FlexGridContextMenu from './FlexGridContextMenu';
import { Selector } from '@grapecity/wijmo.grid.selector';
import * as schemeHelper from './SchemeHelper';
import styles from './DataGridView.module.scss';

import Input from '../Input';
import Util from '../../Util';

import _ from 'lodash';
//import GridGlobalization from './GridGlobalization';
const $ = window.$;

export default class DataGridView extends React.Component {
  constructor(props) {
    super(props);
    this.columnTooltips = new Tooltip({
      position: PopupPosition.Above,
      showAtMouse: true,
      showDelay: 600,
      cssClass: $.strings.dir ? styles.hdr_tip_rtl : 'hdr-tip',
    });
    this.state = {
      defaultValueFilters: schemeHelper.createFilters(props.scheme),
      summaryReducer: schemeHelper.createSummaryReducer(props.scheme),
      footerRows: schemeHelper.createFooterRows(props.scheme),
      //groupColumn: schemeHelper.createGroupColumn(props.scheme, props.scheme.allowGrouping),
      selection: this.flex?this.flex.selection.row:undefined,
      currentSelection: null,
      _defaultRowHeight: this.props.defaultRowHeight || 50,
      customCell: true,
      narrow: false,
      scaleMode: ScaleMode.ActualSize,
      exportMode: ExportMode.All,
      orientation: PdfPageOrientation.Portrait,
      progress: 0,
      selectedItems: undefined,
      buttonsColumns: this.createButtonsColumns(this.props.scheme),
    };
  }
  componentDidMount = () => {
    //GridGlobalization();
    this.setState(
      {
        _defaultRowHeight: this.flex ? this.flex.rows.defaultSize * 2 : this.state._defaultRowHeight,
      },
      () => this._updateGridLayout()
    );

    if (this.columnPicker) {
      hidePopup(this.columnPicker.hostElement);
    }
    window.addEventListener('resize', this._updateGridLayout());
    if (this.flex) {
      this.flex.addEventListener(window, 'resize', this._updateGridLayout());
    }

    this.loadGridState();
    window['grid'] = this.flex;
  };

  createButtonsColumns = () => {
    let schemePtr = schemeHelper.create(this.props.scheme);
    let columns = schemePtr.columns.filter((col) => !col.visible || col.visible === true);
    let buttonsColumns = [];
    columns.map((col, index) => {
      if (col.buttonBody && col.buttonBody === 'button') {
        buttonsColumns.push({
          colName: col.name,
          template: CellMaker.makeButton({
            attributes: { title: col.title },
            cssClass: this.setButtonClass(col.className, col.iconType),
            click: col.onClick,
          }),
        });
      }
    });
    return buttonsColumns;
  };

  dooo = () => {
    this.loadGridState();
  };

  render = () => {
    let schemePtr = schemeHelper.create(this.props.scheme);
    let columns = schemePtr.columns.filter((col) => !col.visible || col.visible === true);
    if (this.state.columns) {
      columns = this.state.columns;
    }
    this.filterColumns = [];
    columns.forEach((element) => {
      if (element.filterable !== false) this.filterColumns.push(element.name);
    });

    return (
      <div>
        {/* <button onClick={this.dooo}>Load</button> */}
        {schemePtr.filter && (
          <div className="p-grid">
            <div className="p-col-12 p-lg-12 p-sm-12">
              <Input
                style={{ width: '100%' }}
                innerRef={(e) => {
                  this.txtFilter = e;
                }}
                onInput={this.filter.bind(this)}
                placeholder={$.strings.globalFilter}
                autoFocus={true}
                value={this.state.filterTextValue}
                onKeyDown={this.onKeyDown}
              />
            </div>
          </div>
        )}
        {schemePtr.allowGrouping && !this.state.narrow && (
          <GroupPanel className="group-panel" grid={this.state.flex} placeholder={$.strings.groupingRow} />
        )}

        <FlexGrid
          id="theGridTallRows"
          headersVisibility={this.props.headersVisibility ? this.props.headersVisibility : 'Column'}
          isReadOnly={this.props.isReport ? true : false}
          quickAutoSize={false}
          quickRowHeights={false}
          initialized={this.initialized.bind(this)}
          itemsSource={this.props.dataSource}
          {...this.props}
          wordWrap={true}
          loadingRows={(s, e) => this.columnTooltips.dispose()}
          keyActionEnter={this.props.isReport ? '0' : this.props.keyActionEnter}
        >
          {this.props.allowDragging && (this.props.allowDragging === 'Rows' || this.props.allowDragging === 'Both') && (
            <FlexGridCellTemplate cellType="RowHeader" template={this.rowHeaderTemplate} />
          )}
          {columns.map((col, index) => {
            return (
              <FlexGridColumn
                key={index}
                name={col.name}
                header={col.header}
                binding={col.name}
                width={col.width}
                multiLine={true}
                isRequired={col.isRequired || false}
                aggregate={col.aggregate}
                allowSorting={schemePtr.sortable && col.sortable !== false}
                visible={col.visible}
                wordWrap={true}
                autoRowHeights={this.props.dataSource.length < 500 ? true : false}
                isReadOnly={col.isReadOnly ? true : false}
                minWidth={col.minWidth}
                isContentHtml={col.isContentHtml}
                cellTemplate={col.buttonBody==="button"?this.createButton(col):undefined}
                editor={col.editor ? col.editor : undefined}
                align={col.align}
                maxLength={col.maxLength}
                cssClass={col.align && col.align === 'left' ? styles.valueLeftStyle : ''}
                dataType={col.dataType}
                format={col.format}
              >
                {col.body && <FlexGridCellTemplate cellType="Cell" template={col.body} />}
              </FlexGridColumn>
            );
          })}
          {
            schemePtr.filter && <FlexGridFilter ref={(ref) => (this.gridFilters = ref)} />
            // initialized={this.initializedFilter.bind(this)} filterColumns={filterColumns} />
          }
        </FlexGrid>
        <ListBox initialized={this.initializedPicker.bind(this)} />
      </div>
    );
  };

  getGridFilter = () => {
    return (
      this.gridFilters &&
      JSON.parse(this.gridFilters.control.filterDefinition).filters.map((filter) => ({
        column: filter.binding,
        values: Object.keys(filter.showValues),
      }))
    );
  };

  rowHeaderTemplate = (context) => {
    return (
      <i
        className="pi pi-bars"
        style={{
          fontSize: '15pt',
          fontWeight: 'bold',
          marginTop: '5px',
          width: '100%',
        }}
        title={$.strings.recordsOrder}
      />
    );
  };

  createButton = (col) => {
    if (col.name === '') {
      alert(' Add Column Name');
    }
    let button = this.state.buttonsColumns.find((e) => e.colName === col.name);
    if (button) {
      return button.template;
    }
    return undefined;
  };




  // saveGridState(flexGrid, scheme) {
  //   if (!flexGrid) return;
  //   let state = {
  //     columns: JSON.parse(flexGrid.columnLayout).columns,
  //     sortDescriptions: flexGrid.collectionView.sortDescriptions.map(function (sortDesc) {
  //       return { property: sortDesc.property, ascending: sortDesc.ascending };
  //     }),
  //   };
  //   localStorage[scheme.name] = JSON.stringify(state);
  // }

  saveGridState(flexGrid, scheme) {
  if (!flexGrid) return;

  const state = {
    columns: flexGrid.columns.map((col) => ({
      binding: col.binding,
      visible: col.visible,
      className: col.className,
      iconType: col.iconType,
    })),
    sortDescriptions: flexGrid.collectionView.sortDescriptions.map((sortDesc) => ({
      property: sortDesc.property,
      ascending: sortDesc.ascending,
    })),
  };

  localStorage.setItem(scheme.name, JSON.stringify(state));
}

loadGridState = () => {
  const json = localStorage.getItem(this.props.scheme.name);
  if (!json || !this.flex) return;

  const state = JSON.parse(json);
  const view = this.flex.collectionView;

  // Restore sorting
  if (view && state.sortDescriptions) {
    view.deferUpdate(() => {
      view.sortDescriptions.clear();
      state.sortDescriptions.forEach((sortDesc) => {
        view.sortDescriptions.push(
          new wjcCore.SortDescription(sortDesc.property, sortDesc.ascending)
        );
      });
    });
  }

  // Restore visibility and cssClass
  if (state.columns) {
    state.columns.forEach((savedCol) => {
      const gridCol = this.flex.columns.getColumn(savedCol.binding);
      if (gridCol) {
        gridCol.visible = savedCol.visible;

        // ✅ Rebuild cssClass from saved props
        if (savedCol.className || savedCol.iconType) {
          gridCol.cssClass = this.setButtonClass(savedCol.className, savedCol.iconType);
        }
      }
    });
  }
};

  // loadGridState = () => {
  //   var json = localStorage.getItem(this.props.scheme.name);
  //   if (json) {
  //     let state = JSON.parse(json);
  //     if (this.flex) {
  //       var view = this.flex.collectionView;
  //       if (view) {
  //         view.deferUpdate(function () {
  //           view.sortDescriptions.clear();
  //           for (var i = 0; i < state.sortDescriptions.length; i++) {
  //             var sortDesc = state.sortDescriptions[i];
  //             view.sortDescriptions.push(new wjcCore.SortDescription(sortDesc.property, sortDesc.ascending));
  //           }
  //         });
  //       }
  //       this.setState({ columns: state.columns });
  //     }
  //   }
  // };

  setButtonClass = (className, iconType) => {
    let _className = '';
    switch (className.toLowerCase()) {
      case 'danger': {
        _className = 'cellMaker-button-danger';
        break;
      }
      case 'warning': {
        _className = 'cellMaker-button-warning';
        break;
      }
      case 'info': {
        _className = 'cellMaker-button-info';
        break;
      }
      case 'success': {
        _className = 'cellMaker-button-success';
        break;
      }
      default: {
        _className = 'cellMaker-button';
        break;
      }
    }
    switch (iconType.toLowerCase()) {
      case 'search': {
        _className += ' pi pi-search';
        break;
      }
      case 'card': {
        _className += ' pi pi-id-card';
        break;
      }
      case 'view':
      case 'eye': {
        _className += ' pi pi-eye';
        break;
      }
      case 'edit': {
        _className += ' pi pi-pencil';
        break;
      }
      case 'delete': {
        _className += ' pi pi-trash';
        break;
      }
      case 'add': {
        _className += ' pi pi-plus';
        break;
      }
      case 'handle': {
        _className += ' pi pi-check-square';
        break;
      }
      case 'user': {
        _className += ' pi pi-user';
        break;
      }
      case 'send': {
        _className += ' pi pi-send';
        break;
      }
      case 'key': {
        _className += ' pi pi-key';
        break;
      }
      case 'upload': {
        _className += ' pi pi-cloud-upload';
        break;
      }
      case 'download': {
        _className += ' pi pi-cloud-download';
        break;
      }
      case 'open': {
        _className += ' pi pi-folder-open';
        break;
      }
      case 'password': {
        _className += ' pi pi-key';
        break;
      }
      case 'log': {
        _className += ' pi pi-clock';
        break;
      }
      default: {
        break;
      }
    }
    return _className;
  };
  filter = (e) => {
    try {
      let txt = e.target.value;
      this.setState({ filterTextValue: txt });
      this.doFilterText(txt);
      this.flex.select(0, 0);
    } catch (e) {}
  };

  doFilterText = (txt) => {
    const schemePtr = schemeHelper.create(this.props.scheme);

    if (this.flex && this.flex.collectionView) {
      this.flex.collectionView.filter = (item) => {
        let result = false;
        for (let i = 0; i < schemePtr.columns.length; i++) {
          if (!schemePtr.columns[i].body && schemePtr.columns[i].body !== 'button' && schemePtr.columns[i].visible !== false) {
            let r = item[schemePtr.columns[i].name] + '';
            r = txt.length === 0 || r.toString().toLowerCase().indexOf(txt.toLowerCase()) > -1;
            if (r) {
              result = true;
              break;
            }
          }
        }

        return txt.length === 0 || result;
      };
    }
  };
  initialized(flexgrid) {
    this.flex = flexgrid;
    if (this.flex) {
      this.flex.rowHeaders.columns[0].allowResizing = false;
      this.flex.selectionMode = wjcCore.asEnum(3, wjGrid.SelectionMode);
      if (!this.props.isReport) {
        this.flex.selectionMode = wjcCore.asEnum(1, wjGrid.SelectionMode);
      }
      if (this.props.columnHeaderHeight) this.flex.columnHeaders.rows[0].height = this.props.columnHeaderHeight;
      this.flex.columns.height = 150;
      // this.flex.autoSizeRow(0, true); header 2 row height
      // add blank row initially
      //this.flex.rows.push(new wjGrid.Row({notes:''}))
      if (this.props.allowDragging === 'Rows' || this.props.allowDragging === 'Both') {
        //this.flex.selectionMode = wjcCore.asEnum(5, wjGrid.SelectionMode);
        //this.flex.allowSorting = false;
      }

      if (this.props.onKeyDown) {
        this.flex.hostElement.addEventListener('keydown', (e) => {
          // let currentRow = this.flex.selection.row,
          // row = this.flex.rows[currentRow];

          // if(e.keyCode == 13 && currentRow == this.flex.rows.length-1 && row && row.dataItem.notes){
          //     this.flex.collectionView.addNew() // create new item and insert it to the last position
          //     this.flex.startEditing(true,currentRow+1,4) // move selection to next row first editable cell and start editing
          // }
          this.props.onKeyDown(this.flex, e);
        });
      }

      //////////// Add Footer Row
      let schemePtr = schemeHelper.create(this.props.scheme);

      this.setState({ flex: flexgrid });
      if (schemePtr.showFooter) {
        this.flex.columnFooters.rows.push(new wjGrid.GroupRow());
        this.flex.bottomLeftCells.setCellData(0, 0, '');
      }
      let narrow = this.flex ? this.flex.hostElement.clientWidth < 400 : false;
      //////////// Responsive Mode
      this.flex.formatItem.addHandler((s, e) => {
        // columns tooltip
        if (e.panel === s.columnHeaders) {
          let column = schemePtr.columns.find((col) => col.buttonBody !== 'button' && col.name === e.getColumn().name);

          if (column && column.tooltip) {
            let tooltipText = column.tooltip;
            let textAlign = $.strings.dir === 'rtl' ? 'right' : 'left';
            let tooltipHtml = "<div style='text-align:" + textAlign + " class='col-header'>" + tooltipText + '</div>';
            this.columnTooltips.setTooltip(e.cell, tooltipHtml);
          }
        }

        // show rows as cards on narrow layout

        if (e.panel === s.cells && e.col === schemePtr.responsiveColumnIndex && narrow) {
          let format = this.getColumnReponsive();

          let html = wjcCore.format(format, s.rows[e.row].dataItem);
          e.cell.innerHTML = html;
          let hiddenColCount = 0;

          for (let index = 0; index < schemePtr.columns.length; index++) {
            let col = s.columns[index];

            if (e.row >= 0 && col.binding === 'status') {
              let data = s.getCellData(e.row, col.index);

              let newData = data;

              if (data + '' === '1' || data + '' === '2') {
                newData = Util.getStatusName(data);
              }

              let color = '';
              if (newData === $.strings.active || newData + '' === '1') {
                color = 'limegreen';
              } else {
                color = 'red';
              }
              let newHtml =
                '<span style="font-size:18px">' +
                $.strings.status +
                ': ' +
                '<span style="color:' +
                color +
                ';">' +
                newData +
                "<i class='pi pi-flag-fill'/></span></span>";
              let cellHtml = undefined;

              if (data === $.strings.active || data + '' === '1') {
                if (html.includes('<div class="item-detail">' + $.strings.status + ': ' + newData + '</div>')) {
                  cellHtml = html.replace(
                    '<div class="item-detail">' + $.strings.status + ': ' + newData + '</div>',
                    wjcCore.Globalize.format(newHtml, col.format)
                  );
                } else {
                  cellHtml = html.replace(
                    '<div class="item-detail">' + $.strings.status + ': 1</div>',
                    wjcCore.Globalize.format(newHtml, col.format)
                  );
                }
              } else if (data === $.strings.inactive || data + '' === '2') {
                if (html.includes('<div class="item-detail">' + $.strings.status + ': ' + newData + '</div>')) {
                  cellHtml = html.replace(
                    '<div class="item-detail">' + $.strings.status + ': ' + newData + '</div>',
                    wjcCore.Globalize.format(newHtml, col.format)
                  );
                } else
                  cellHtml = html.replace(
                    '<div class="item-detail">' + $.strings.status + ': 2</div>',
                    wjcCore.Globalize.format(newHtml, col.format)
                  );
              }

              e.cell.innerHTML = cellHtml;
            }
          }

          hiddenColCount = 0;
          for (let index = 0; index < schemePtr.columns.length; index++) {
            if (schemePtr.columns[index].visible === false) {
              hiddenColCount++;
            } else {
              if (schemePtr.columns[index].buttonBody && schemePtr.columns[index].buttonBody === 'button') {
                let temp = index;
                temp = (temp - hiddenColCount) * 2;
                //if(e.cell.childNodes[temp]){
                e.cell.childNodes[temp].addEventListener('click', (event) => {
                  this.onButtonClick(event, index, s.rows[e.row].dataItem);
                });
                //}
              }
            }
          }
        }
      });
      //////////// Custome Footer Calculation
      this.flex.itemsSourceChanged.addHandler((s, e) => {
        //this.filter();
        if (schemePtr.showFooter) {
          let columns = schemePtr.columns;
          columns = columns.filter((col) => col.customAggregate === true && col.dataType === 'Time');
          if (columns && columns.length > 0 && flexgrid.itemsSource) {
            let total = { hours: 0, minutes: 0 };
            columns.forEach((col) => {
              total = { hours: 0, minutes: 0 };
              flexgrid.itemsSource.forEach(function (item) {
                let value = item[col.name] || '0:0';
                var parts = value.split(':');
                var temp;
                temp = +parts[1] + total.minutes;
                total.minutes = temp % 60;
                total.hours = +parts[0] + total.hours + (temp - total.minutes) / 60;
              });
              let transTime = this.zeroPad(total.hours) + ':' + this.zeroPad(total.minutes);

              if (!transTime.startsWith('Na')) {
                flexgrid.columnFooters.setCellData(flexgrid.columnFooters.rows.length - 1, schemePtr.columns.indexOf(col), transTime, true);
              }
            });
          }
          if (this.state.filterTextValue) this.doFilterText(this.state.filterTextValue);
        }
        this.loadGridState();
        this._updateGridLayout();
      });

      //////////// Context Menu
      if (this.props.showContextMenu !== false && !narrow) {
        new FlexGridContextMenu(
          flexgrid,
          this.props.scheme,
          this.showColumnPicker,
          this.props.exportFileName,
          this.saveGridState,
          this.props.allowExcelExport
        );
      }

      if (this.props.checkBoxSelector) {
        this.selector = new Selector(flexgrid, {
          itemChecked: (s, e) => {
            this.setState({
              selectedItems: flexgrid.rows.filter((r) => r.isSelected),
            });
          },
        });
      }

      // Double Click
      if (this.props.onRowDoubleClick) {
        flexgrid.hostElement.addEventListener('dblclick', (e) => {
          try {
            if (flexgrid.selection && flexgrid.selection._row > -1) {
              let hti = flexgrid.hitTest(e);
              if (hti.cellType === wjGrid.CellType.Cell && (e.target.classList[0] === 'wj-cell' || e.target.classList.length <= 0)) {
                this.props.onRowDoubleClick(flexgrid.rows[flexgrid.selection._row].dataItem);
              }
            }
          } catch (e) {}
        });
      }
    }

    if (this.props.columnsCustomMenu) {
      let menu = this.props.columnsCustomMenu();
      flexgrid.menu = menu;
      flexgrid.hostElement.addEventListener(
        'contextmenu',
        (e) => {
          this.props.registerContextMenuEvent(e, flexgrid, flexgrid.menu);
        },
        true
      );
    }
  }

  initializedFilter(filter) {
    this.filterGrid = filter;
    if (this.filterGrid) {
      // editing filter
      this.filterGrid.editingFilter.addHandler((s, e) => {
        if (e.getColumn().binding === 'status') {
          // let vals = [];
          // let valueFilter = s.getColumnFilter("status", true).valueFilter;
          // valueFilter.uniqueValues = null;
          // valueFilter.getUniqueValues().forEach(item => {
          //   item.text + "" === "1" ? vals.push($.strings.active) : vals.push($.strings.inactive);
          // });
          // valueFilter.uniqueValues = vals;
        }
      });

      // filter changing
      this.filterGrid.filterChanged.addHandler((s, e) => {
        this.filterGrid.onFilterApplied(e);
      });
    }
  }

  clearFilters() {
    if (this.flex) {
      let rowIndex = this.flex.selection.row;
      let colIndex = this.flex.selection.row;

      this.setState({ filterTextValue: '' }, () => {
        //this.focus();
        //this.select(rowIndex, colIndex);
        //this.scrollIntoView(rowIndex, colIndex);
        if (this.txtFilter) this.txtFilter.focus();
      });
    }
  }

  focus = () => {
    if (this.flex) this.flex.focus();
  };
  refresh = (fullUpdate) => {
    if (this.flex) this.flex.refresh(fullUpdate);
  };
  select = (row, col) => {
    if (this.flex) this.flex.select(row, col);
  };
  scrollIntoView = (row, col) => {
    if (this.flex) {
      this.flex.scrollIntoView(row, col, false);
      this.flex.scrollPosition = {
        ...this.flex.scrollPosition,
        x: -this.flex.scrollSize.width,
      };
    }
  };
  startEditing = (row, col) => {
    //this.flex.startEditing(true, row, col, true);
  };
  zeroPad = (num) => {
    var str = num.toString();
    if (str.length < 2) {
      str = '0' + str;
    }
    return str;
  };
  getColumnReponsive = () => {
    const schemePtr = schemeHelper.create(this.props.scheme);
    let format = [];
    let columns = schemePtr.columns;
    if (this.state.columns) {
      columns = this.state.columns;
    }
    if (!columns || columns.length <= 0) {
      return;
    }

    for (let index = 0; index < columns.length; index++) {
      if (columns[index].visible === false) {
        continue;
      }
      let col = columns[index];

      let name = col.name;
      let caption = col.header + '';
      if (caption && caption.length > 0) {
        caption += ': ';
      }
      if (this.state.narrow) {
        // Responsive
        let objCol = this.props.scheme.columns.find((e) => e.name === col.name);

        if (objCol && objCol.buttonBody && objCol.buttonBody === 'button') {
          let buttonHtml =
            '<button style="margin-top:10px;margin-bottom:10px;" class=\'' + this.setButtonClass(objCol.className, objCol.iconType) + "'  ";
          buttonHtml += '></button>';
          format.push(buttonHtml);
        } else {
          format.push('<div class="item-detail">' + caption + '{' + name + '}</div>');
        }
      } else {
        if (col.buttonBody && col.buttonBody === 'button') {
          let buttonHtml = '<button style="margin-top:10px;margin-bottom:10px;" class=\'' + this.setButtonClass(col.className, col.iconType) + "' ";
          buttonHtml += '></button>';
          format.push(buttonHtml);
        } else {
          format.push('<div class="item-detail">' + caption + '{' + name + '}</div>');
        }
      }
    }

    let html = format.join(' ');

    return html;
  };

  onButtonClick(e, colIndex, item) {
    const schemePtr = schemeHelper.create(this.props.scheme);
    let ctx = { item: item };
    schemePtr.columns[colIndex].onClick(e, ctx);
  }

  _updateGridLayout = () => {
    const schemePtr = schemeHelper.create(this.props.scheme);
    // show/hide columns
    let narrow = this.flex ? this.flex.hostElement.clientWidth < 400 : false;
    if (this.flex) {
      this.flex.columns.forEach((col) => {
        col.visible = col.index === schemePtr.responsiveColumnIndex ? narrow : !narrow;
        if (!narrow) {
          for (let index = 0; index < schemePtr.columns.length; index++) {
            if (schemePtr.columns[index].name === col.name) {
              col.visible = schemePtr.columns[index].visible === false ? false : true;
              break;
            }
          }
        }
      });

      // make rows taller on phone layout
      let columns = schemePtr.columns.filter((col) => col.visible === undefined || col.visible === null || col.visible === true);
      let visibleColumnsCount = schemePtr.columns.length;

      if (columns && columns.length > 0) {
        visibleColumnsCount = columns.length;
      }
      //this.flex.rows.defaultSize = this.state._defaultRowHeight * (narrow ? (visibleColumnsCount + 3) : 1); // if autoRowHeight===false;
      if (narrow) {
        this.flex.rows.defaultSize = this.state._defaultRowHeight * (narrow ? visibleColumnsCount * 1.7 : 1); // if autoRowHeight===false;
        this.flex.rows.defaultSize = this.flex.rows.defaultSize / 1.5;
      } else {
        if (!this.props.defaultRowHeight) {
          this.flex.rows.defaultSize = this.state._defaultRowHeight * (narrow ? visibleColumnsCount + 5 : 1);
        } else {
          this.flex.rows.defaultSize = this.props.defaultRowHeight * (narrow ? visibleColumnsCount + 5 : 1);
        }
      }
      //this.flex.rows.defaultSize = this.state._defaultRowHeight; // if autoRowHeight===true;
      // hide column headers on narrow layouts
      this.flex.headersVisibility = narrow ? 'None' : this.props.headersVisibility ? this.props.headersVisibility : 'Column';
      this.setState({ narrow: narrow });
    }
  };

  getColumns = () => {
    let listOfColumns = [];
    let narrow = this.flex ? this.flex.hostElement.clientWidth < 400 : false;
    let objResult = { isMobile: narrow, listOfColumns: [] };
    if (narrow) {
      const schemePtr = schemeHelper.create(this.props.scheme);
      let columns = schemePtr.columns;
      if (this.state.columns) {
        columns = this.state.columns;
      }
      if (!columns || columns.length <= 0) {
        return;
      }

      for (let index = 0; index < columns.length; index++) {
        if (columns[index].visible === false && columns[index].visibleInPrint !== true) {
          continue;
        }
        let col = columns[index];
        let objGridCol = this.flex.columns.find((gridCol) => gridCol.name === col.name);
        if (objGridCol) {
          objGridCol.columnWidth = col.columnWidth;
          listOfColumns.push(objGridCol);
        }
      }
    } else {
      let columns = this.flex.columns; //schemePtr.columns.filter(col => col.visible === undefined || col.visible === null || col.visible === true)
      const schemePtr = schemeHelper.create(this.props.scheme);
      if (schemePtr.columns) {
        for (let i = 0; i < columns.length; i++) {
          let obj = schemePtr.columns.find((e) => e.name === columns[i].name);
          if (obj && (columns[i].visible || obj.visibleInPrint === true)) {
            if (!columns[i].visible && obj.visibleInPrint === true) columns[i].visible = false;
            columns[i].columnWidth = obj.columnWidth;
            listOfColumns.push(columns[i]);
          }
        }
      }
    }
    objResult.listOfColumns = listOfColumns;
    return objResult;
  };

  getGridState = () => {
    return this.flex ? this.flex.hostElement.clientWidth < 400 : false;
  };
  // Print Grid
  printDoc() {
    // create PrintDocument
    let dir = $.strings.dir;
    let doc = new wjcCore.PrintDocument({
      title: 'HR Self-Service',
      copyCss: false, // prevent cross-origin issues in jsfiddle
    });
    doc.addCSS('direction', dir);
    // add CSS explicitly (since we can't use copyCss in jsfiddle)
    doc.append('<link href="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css" rel="stylesheet">');
    doc.append('<link href="https://cdn.grapecity.com/wijmo/5.latest/styles/wijmo.min.css" rel="stylesheet">');
    // add some simple text
    doc.append('<div style="direction:' + dir + ';text-align:center ">');
    doc.append('<h1>قائمة الموظفين</h1>');
    doc.append('</div>');
    doc.append('<div style="direction:' + dir + '">');
    doc.append('<p> قائمة الموظفين الخاصة<b> بشركة اسراء للبرمجة والكمبيوتر </b></p>');
    // add a printer-friendly version of a FlexGrid to the document
    doc.append('<p>نابلس شارع فيصل هاتف 2373001 فاكس 2373002</p>');
    doc.append('</div>');
    let tbl = this.renderTable(dir);
    doc.append(tbl);
    // print the document
    doc.print();
  }
  // renders grid as a table
  renderTable(direction) {
    // start table
    let tbl = '<table style="direction:' + direction + ';border:1px solid black;border-collapse: collapse ">';
    // headers
    if (this.flex.headersVisibility & wjGrid.HeadersVisibility.Column) {
      tbl += '<thead style="border:1px solid black">';
      for (let r = 0; r < this.flex.columnHeaders.rows.length; r++) {
        tbl += this.renderRow(this.flex.columnHeaders, r, true);
      }
      tbl += '</thead>';
    }
    // body
    tbl += '<tbody style="border:1px solid black">';
    for (let r = 0; r < this.flex.rows.length; r++) {
      tbl += this.renderRow(this.flex.cells, r, false);
    }
    tbl += '</tbody>';
    // footers
    if (this.flex.columnFooters && this.flex.columnFooters.rows.length > 0) {
      tbl += '<tfoot style="border:1px solid black">';
      for (let r = 0; r < this.flex.columnFooters.rows.length; r++) {
        tbl += this.renderRow(this.flex.columnFooters, r, true);
      }
      tbl += '</tfoot>';
    }
    // done
    tbl += '</table>';

    return tbl;
  }
  renderRow(panel, r, isColumnHeader) {
    let tr = '',
      row = panel.rows[r];
    if (row.renderSize > 0) {
      tr += '<tr>';
      for (let c = 0; c < panel.columns.length; c++) {
        let col = panel.columns[c];
        if (col.renderSize > 0 && !col.cellTemplate) {
          // get cell style, content
          let style = 'width:' + col.renderSize + 'px;';
          if (isColumnHeader) {
            style += 'text-align:center;';
          } else {
            style += 'text-align:' + col.getAlignment() + ';';
          }
          style += 'padding-right: 6px;border:1px solid black;';

          let content = panel.getCellData(r, c, true);
          if (!row.isContentHtml && !col.isContentHtml) {
            content = wjcCore.escapeHtml(content);
          }
          // add cell to row
          switch (panel.cellType) {
            case wjGrid.CellType.ColumnHeader: {
              tr += '<th style="' + style + '">' + content + '</th>';
              break;
            }
            case wjGrid.CellType.ColumnFooter: {
              style += 'bgcolor:Black;color:white;';
              tr += '<th style="' + style + '">' + content + '</th>';
              break;
            }
            default: {
              // show boolean values as checkboxes
              let raw = panel.getCellData(r, c, false);
              if (raw === true) {
                content = '&#9745;';
              } else if (raw === false) {
                content = '&#9744;';
              }
              tr += '<td style="' + style + '">' + content + '</td>';
              break;
            }
          }
        }
      }
      tr += '</tr>';
    }
    return tr;
  }

  // Export Grid To PDF
  exportPDF() {
    FlexGridPdfConverter.export(this.flex, this.props.exportFileName ? this.props.exportFileName : 'FlexGrid.pdf', {
      maxPages: 10,
      exportMode: this.state.exportMode,
      scaleMode: this.state.scaleMode,
      documentOptions: {
        pageSettings: {
          layout: this.state.orientation,
        },
        header: {
          declarative: {
            text: '\t&[Page]\\&[Pages]',
          },
        },
        footer: {
          declarative: {
            text: '\t&[Page]\\&[Pages]',
          },
        },
      },
      styles: {
        cellStyle: {
          backgroundColor: '#ffffff',
          borderColor: '#c6c6c6',
        },
        altCellStyle: {
          backgroundColor: '#f9f9f9',
        },
        groupCellStyle: {
          backgroundColor: '#dddddd',
        },
        headerCellStyle: {
          backgroundColor: '#eaeaea',
        },
      },
    });
  }

  // Export To Excel
  excelExport() {
    let currentDate = new Date();
    let date = currentDate.getFullYear() + '_' + (currentDate.getMonth() + 1) + '_' + currentDate.getDate();
    let time = currentDate.getMinutes() + ' ' + currentDate.getHours() + ' ';

    let dateStr = date + ' ' + time;

    gridXlsx.FlexGridXlsxConverter.saveAsync(
      this.flex,
      {
        includeColumns: function (column) {
          return !column.name.startsWith('btn');
        },
        formatItem: this.formatItemXlsx,
      },
      this.props.exportFileName ? this.props.exportFileName + ' ' + dateStr : 'FlexGrid.xlsx',
      null,
      null,
      (progress) => this.setState({ progress: progress }),
      true
    );
  }
  //
  cancel() {
    gridXlsx.FlexGridXlsxConverter.cancelAsync(() => this.setState({ progress: 0 }));
  }

  exportCSV() {
    let rng = new wjGrid.CellRange(0, 0, this.flex.rows.length - 1, this.flex.columns.length - 1),
      csv = this.flex.getClipString(rng, wjGrid.ClipStringOptions.CSV, true, false);
    saveFile(csv, this.props.exportFileName ? this.props.exportFileName + '.csv' : 'FlexGrid.csv');
  }

  formatItemXlsx = (args) => {
    let p = args.panel,
      row = args.row,
      col = args.col,
      xlsxCell = args.xlsxCell,
      cell;
    if (
      p.cellType === wjGrid.CellType.Cell &&
      (p._cols[col].name.toLowerCase() === 'status' || p._cols[col].name.toLowerCase() === 'checkbooksstatus')
    ) {
      let data = this.flex.getCellData(row, col);
      if (data) {
        xlsxCell.value = Util.getStatusName(data);
      }
    } else if (p.cellType === wjGrid.CellType.Cell && this.flex.columns[args.col].dataType === 3) {
      // boolean
      let data = this.flex.getCellData(row, col);
      if (data) xlsxCell.value = $.strings.yes;
      else xlsxCell.value = $.strings.no;
    }
  };

  // Column Picker (Chooser)
  initializedPicker(picker) {
    this.columnPicker = picker;
  }
  showColumnPicker = () => {
    if (this.flex) {
      this.columnPicker.itemsSource = _.cloneDeep(this.flex.columns);
      let columnsList = [];
      this.flex.columns.forEach((item) => {
        this.props.scheme.columns.forEach((e) => {
          if (e && e.name + '' === item._name + '' && e.visibleInColumnChooser !== false) {
            columnsList.push(item);
          }
        });
      });

      // this.columnPicker.itemsSource = this.props.scheme.columns.filter(e => e.visibleInColumnChooser !== false);
      this.columnPicker.itemsSource = columnsList;
      this.columnPicker.checkedMemberPath = 'visible';
      this.columnPicker.displayMemberPath = 'header';
      this.columnPicker.lostFocus.addHandler(() => {
        hidePopup(this.columnPicker.hostElement);
      });

      let ref = this.flex.hostElement.querySelector('.wj-topleft');
      let host = this.columnPicker.hostElement;
      if (!host.offsetHeight) {
        showPopup(host, ref, false, true, false);
        this.columnPicker.focus();
      } else {
        hidePopup(host, true, true);
        this.flex.focus();
      }
      this.columnPicker.focus();
    }
  };

  getCurrentRowItem = () => {
    try {
      if (!this.flex.selectedItems) return undefined;
      return this.flex.selectedItems.length > 0 ? this.flex.selectedItems[0] : undefined;
    } catch (e) {}
  };
  onKeyDown = (e) => {
    if (e.keyCode === Util.keyboardKeys.Enter) {
      if (this.flex) this.flex.focus();
    }
  };
}
